<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h3 class="card-title">Remover Flow</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p class="mb-3">
                                    Tem certeza que deseja remover o flow
                                    <strong>{{ flow.name }}</strong
                                    >? <br />
                                    <span
                                        >Esta ação não poderá ser
                                        desfeita.</span
                                    >
                                </p>
                                <div class="form-group">
                                    <label class="form-label"
                                        >Para confirmar a remoção, digite abaixo
                                        o texto
                                        <span class="bg-red-lt px-1">{{
                                            flow.name
                                        }}</span
                                        >:</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="flowNameConfirmation"
                                        id="confirmationInput"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col">
                                <a
                                    href="/flows"
                                    class="btn btn"
                                    id="cancelAndBackButton"
                                >
                                    <i class="ti ti-arrow-left"></i>
                                    Cancelar e voltar
                                </a>
                            </div>
                            <div class="col-auto">
                                <a
                                    v-on:click="removeFlow"
                                    class="btn btn-danger"
                                    id="removeFlowButton"
                                >
                                    <i class="ti ti-trash"></i>
                                    Remover o flow
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "../services/api"
import EventBus from "../services/event-bus"

export default {
    name: "FlowDeletePage",
    data() {
        return {
            flowNameConfirmation: "",
            flow: {}
        }
    },
    async mounted() {
        var id = this.$route.params.id
        var response = await Api.flows.get(id)
        this.flow = response.data
    },
    methods: {
        async removeFlow() {
            var id = this.$route.params.id
            try {
                if (this.validate()) {
                    await Api.flows.delete(id)

                    this.$router.push("/flows")

                    EventBus.emit("message", {
                        type: "success",
                        message: "Flow removido com sucesso!"
                    })
                }
            } catch (error) {
                EventBus.emit("message", {
                    type: "error",
                    message: "Erro ao remover Flow:" + error
                })
            }
        },
        validate() {
            if (this.flow.name !== this.flowNameConfirmation) {
                EventBus.emit("message", {
                    type: "warning",
                    message: "O nome do flow não confere com o nome digitado!"
                })

                return false
            }
            return true
        }
    }
}
</script>
